/**
 * Returns the browser's native scrollbar width in pixels.
 * Varies by OS/theme (e.g. ~15px macOS, ~17px Windows).
 */
export const getScrollbarWidth = (): number => {
  const outer = document.createElement('div')
  outer.style.cssText =
    'visibility:hidden;overflow:scroll;position:absolute;width:100px;height:100px'
  document.body.appendChild(outer)

  const inner = document.createElement('div')
  outer.appendChild(inner)

  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth
  outer.remove()
  return scrollbarWidth
}
